import { useQuery } from "@tanstack/react-query";
import { useAuth } from "@clerk/clerk-react";
import { getOpinionPlainText } from "../api/get-plain-text";

export const useOpinionPlainText = ({ opinionId }: { opinionId: string }) => {
  const { getToken } = useAuth();
  const {
    data: opinionPlainText,
    isLoading,
    refetch,
  } = useQuery({
    queryKey: ["opinion-plain-text", opinionId],
    queryFn: () => getOpinionPlainText({ getToken, opinionId }),
    enabled: Boolean(opinionId),
  });

  return { opinionPlainText, isLoading, refetch };
};
